<app-page-header [title]="'Dealership Details'"
                 [subtitle]="'View details of the selected dealership'"></app-page-header>

<!-- Dealership Information -->
<h2 class="text-2xl font-semibold mb-2">Dealership Information</h2>
<div class="mb-6 border border-gray-300 dark:border-gray-700 p-4 rounded-md">
    <div class="grid grid-cols-2 gap-2">
        <div class="flex flex-col gap-1">
            <p><strong>Name:</strong> {{ dealership?.name }}</p>
            <p><strong>ID:</strong> {{ dealership?.id }}</p>
            <p><strong>GSSN:</strong> {{ dealership?.gssn }}</p>
            <p><strong>Created By:</strong> {{ dealership?.createdBy | roleName }}</p>
            <p><strong>Updated By:</strong> {{ dealership?.updatedBy | roleName }}</p>
        </div>
    </div>
</div>

<!-- Country Details -->
@if (dealership?.country) {
    <div class="mb-6">
    <h2 class="text-2xl font-semibold mb-2">Country</h2>
    <div class="border border-gray-300 dark:border-gray-700 p-4 rounded-md">
        <div class="flex justify-between">
            <div>
                <p><strong>Name:</strong> {{ dealership?.country?.name }}</p>
            </div>
            <p-button
                    label="View Country"
                    icon="pi pi-eye"
                    routerLink="/countries/country/{{dealership?.country?.id}}"
                    outlined
            ></p-button>
        </div>
    </div>
    </div>
}

<!-- Action Buttons -->
<div class="flex justify-between items-center mt-6">
    <div class="flex gap-3">
        <p-button (click)="openEditDialog()" icon="pi pi-pencil" isAdmin label="Edit" severity="secondary"
                  text></p-button>
        <p-button (click)="deleteDealership()" icon="pi pi-trash" isAdmin label="Delete" severity="danger"
                  text></p-button>
    </div>
    <p-button label="Back to Dealerships" icon="pi pi-arrow-left" text routerLink="/dealerships"></p-button>
</div>

<!-- Update Dialog -->
<app-update-dealership-dialog
        [(visible)]="displayUpdateDialog"
        [dealership]="editableDealership"
        (dealershipUpdated)="reloadDealershipDetails()"
></app-update-dealership-dialog>
